import styled from 'styled-components';
export const DivIconHtmlElement = styled.div `
  svg {
    position: absolute;
    width: 0;
    height: 0;
  }
`;
export const SpanIconHtmlElement = styled.span `
  display: none;
`;
export const IIconHtmlElement = styled.i `
  display: none;
`;
export const IconSVG = styled.svg `
  ${(props) => props.hasNoSize &&
    `
    width: 50px;
    height: 50px;
  `}
`;
//# sourceMappingURL=icon.styles.js.map